import React from 'react';
import __ from "lodash";
import {
  Icon,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide, ListItemText, ListItem
} from '@material-ui/core';
import {CheckboxEditor} from "../controls";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmDialog = (props) => {
  const title = props.title;
  const message = props.message;
  const secondMessage = props.secondMessage;
  const buttons = props.buttons;
  const onChange = props.onChange;

  let checkBoxes = null;
  if (__.has(props, "checkBoxes")) {
    checkBoxes = props.checkBoxes;
  }

  const buttonHandler = (value) => {
    onChange(value);
  }

  return (
    <div>
      <Dialog id="alert-dialog-slide"
        style={{zIndex: 1510}}
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={(event, reason)=>{if (reason !== 'backdropClick') buttonHandler(props.closeValue===undefined?false:props.closeValue)}}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        // disableBackdropClick={true}
        {...props.dialogOptions}
      >
        <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {message}
          </DialogContentText>
          {secondMessage
            ?
              <DialogContentText id="alert-dialog-slide-description">
                {secondMessage}
              </DialogContentText>
            :
              <></>
          }
          {checkBoxes
            ?
              <div style={{display: "flex"}}>
                {checkBoxes.map(checkBox => (
                  <ListItem key={checkBox.label} style={checkBox.style} dense >
                    <CheckboxEditor value={checkBox.value} onChange={checkBox.onChange} key={checkBox.label} disabled={checkBox.disabled}/>
                    <ListItemText id={checkBox.label} primary={checkBox.label} />
                  </ListItem>
                ))}
              </div>
            :
              <></>
          }
        </DialogContent>
        <DialogActions>
          {
            buttons.map(button => (
              <Button startIcon={(<Icon {...button.options}>{button.icon}</Icon>)} onClick={()=>buttonHandler(button.value)} key={button.label}>
                {button.label}
              </Button>
            ))
          }
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ConfirmDialog;
